// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const extractYouTubeID = url => {
  const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts|live)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
  const match = url ? url.match(regExp) : null;

  return match ? match[1] : null;
};

export function stringToArray(value, separator = ',') {
  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'string') {
    return value.split(separator);
  }

  return [];
}

/**
 * Deduplicates keywords array, case-insensitive comparison.
 * Converts all keywords to lowercase and trims whitespace.
 * Filters out empty strings.
 *
 * @param {string[]|string} keywords - Keywords as array or comma-separated string
 * @returns {string[]} - Deduplicated keywords array in lowercase
 */
export function deduplicateKeywords(keywords) {
  if (!keywords) {
    return [];
  }
  // Convert to array if string
  const keywordsArray = Array.isArray(keywords)
    ? keywords
    : typeof keywords === 'string'
    ? keywords
        .split(',')
        .map(k => k.trim())
        .filter(k => k.length > 0)
    : [];
  // Use a Map to track seen keywords (case-insensitive)
  const seen = new Map();
  const result = [];
  keywordsArray.forEach(keyword => {
    const trimmed = keyword.trim();
    if (trimmed.length === 0) {
      return;
    }
    const normalized = trimmed.toLowerCase();
    if (!seen.has(normalized)) {
      seen.set(normalized, true);
      result.push(normalized);
    }
  });
  return result;
}
